(function () {
  var indexCache = {};

  function normalize(value) {
    var text = String(value || "");
    try {
      text = text.normalize("NFKC");
    } catch (error) {
      // Older browsers can still search without Unicode normalization.
    }
    return text.toLowerCase().replace(/[\s\u3000]+/g, " ").trim();
  }

  function tokenize(query) {
    return normalize(query).split(/[ ,、]+/).filter(Boolean);
  }

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function metaLabel(value) {
    return String(value || "").trim();
  }

  function prepareItem(item) {
    var maker = metaLabel(item.maker);
    var model = metaLabel(item.model);
    var tags = Array.isArray(item.tags) ? item.tags.join(" ") : "";
    var text = [
      item.title,
      item.handle,
      item.url,
      maker,
      model,
      tags
    ].join(" ");

    return Object.assign({}, item, {
      maker: maker,
      model: model,
      searchText: normalize(text),
      titleText: normalize(item.title),
      handleText: normalize(item.handle)
    });
  }

  function scoreItem(item, query, tokens) {
    var score = 0;

    if (item.titleText === query) score += 220;
    if (item.titleText.indexOf(query) !== -1) score += 120;
    if (item.handleText.indexOf(query) !== -1) score += 40;

    tokens.forEach(function (token) {
      if (item.titleText.indexOf(token) !== -1) score += 45;
      if (item.handleText.indexOf(token) !== -1) score += 20;
      if (normalize(item.maker).indexOf(token) !== -1) score += 30;
      if (normalize(item.model).indexOf(token) !== -1) score += 30;
      if (item.searchText.indexOf(token) !== -1) score += 8;
    });

    score += Math.min(Number(item.impressions || 0), 1000) / 200;
    score += Number(item.score || 0) / 4;
    return score;
  }

  function createBadge(text) {
    var badge = document.createElement("span");
    badge.className = "sk-faq-search__badge";
    badge.textContent = text;
    return badge;
  }

  function renderResults(root, matches, query) {
    var results = root.querySelector("[data-faq-search-results]");
    var status = root.querySelector("[data-faq-search-status]");
    var maxResults = Number(root.dataset.maxResults || 10);
    var visibleMatches = matches.slice(0, maxResults);

    results.innerHTML = "";

    if (!query) {
      status.textContent = "";
      return;
    }

    if (!visibleMatches.length) {
      status.textContent = "該当するFAQは見つかりませんでした";
      return;
    }

    status.textContent = matches.length + "件のFAQが見つかりました";

    visibleMatches.forEach(function (item) {
      var li = document.createElement("li");
      var link = document.createElement("a");
      var title = document.createElement("span");
      var meta = document.createElement("span");

      li.className = "sk-faq-search__item";
      link.className = "sk-faq-search__link";
      link.href = item.url;
      title.className = "sk-faq-search__title";
      title.textContent = item.title;
      meta.className = "sk-faq-search__meta";

      if (item.maker && item.maker !== "未確認") meta.appendChild(createBadge(item.maker));
      if (item.model) meta.appendChild(createBadge(item.model));

      link.appendChild(title);
      if (meta.children.length) link.appendChild(meta);
      li.appendChild(link);
      results.appendChild(li);
    });
  }

  function search(items, query) {
    var normalizedQuery = normalize(query);
    var tokens = tokenize(query);

    if (!normalizedQuery || !tokens.length) return [];

    return items
      .filter(function (item) {
        return tokens.every(function (token) {
          return item.searchText.indexOf(token) !== -1;
        });
      })
      .map(function (item) {
        return {
          item: item,
          score: scoreItem(item, normalizedQuery, tokens)
        };
      })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return Number(b.item.impressions || 0) - Number(a.item.impressions || 0);
      })
      .map(function (entry) {
        return entry.item;
      });
  }

  function loadIndex(url) {
    if (!indexCache[url]) {
      indexCache[url] = window.fetch(url, { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("FAQ search index request failed");
          return response.json();
        })
        .then(function (payload) {
          return (payload.items || []).map(prepareItem);
        });
    }
    return indexCache[url];
  }

  function init(root) {
    var input = root.querySelector("[data-faq-search-input]");
    var clear = root.querySelector("[data-faq-search-clear]");
    var status = root.querySelector("[data-faq-search-status]");
    var form = root.querySelector("form");
    var items = [];

    if (!input || !form) return;

    loadIndex(root.dataset.indexUrl)
      .then(function (loadedItems) {
        items = loadedItems;
      })
      .catch(function () {
        status.textContent = "FAQ検索を読み込めませんでした";
      });

    var runSearch = debounce(function () {
      var query = input.value;
      var matches = search(items, query);
      clear.hidden = !query;
      renderResults(root, matches, normalize(query));
    }, 120);

    input.addEventListener("input", runSearch);

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var matches = search(items, input.value);
      clear.hidden = !input.value;
      renderResults(root, matches, normalize(input.value));
    });

    clear.addEventListener("click", function () {
      input.value = "";
      input.focus();
      clear.hidden = true;
      renderResults(root, [], "");
    });
  }

  function boot() {
    document.querySelectorAll("[data-faq-search]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
